import { useSelector } from 'react-redux'
import {
  appClosingSelector,
  appVisibleAllowedSelector,
  appVisibleSelector,
  drawerHeaderVisibleSelector,
  drawerHideCloseSelector,
  hideNavigateBackSelector,
  progressStepSelector,
} from '@redux/slices/workflowSlice'
import { ROUTES } from '@constants/index'

type UseAppDrawerStateReturn = {
  activeStep: number
  isVisible: boolean
  appClosing: boolean
  appVisibleAllowed: boolean
  showHeader: boolean
  showProgress: boolean
  hideCloseButton: boolean
  hideNavigateBack: boolean
}

export const useAppDrawerState = (): UseAppDrawerStateReturn => {
  const activeStep = useSelector(progressStepSelector)
  const isVisible = useSelector(appVisibleSelector)
  const appClosing = useSelector(appClosingSelector)
  const appVisibleAllowed = useSelector(appVisibleAllowedSelector)
  const showHeader = useSelector(drawerHeaderVisibleSelector)
  const hideCloseButton = useSelector(drawerHideCloseSelector)
  const hideNavigateBack = useSelector(hideNavigateBackSelector)

  const showProgress =
    activeStep !== undefined &&
    activeStep > 0 &&
    !window.location.pathname.endsWith(ROUTES.START) &&
    !window.location.pathname.endsWith(ROUTES.RESUME) &&
    !window.location.pathname.endsWith(ROUTES.ERROR) &&
    !window.location.pathname.endsWith(ROUTES.LOGIN_REDIRECT)

  return {
    activeStep: activeStep ?? 0,
    isVisible,
    appClosing,
    appVisibleAllowed,
    showHeader,
    showProgress,
    hideCloseButton,
    hideNavigateBack,
  }
}
